import { useFormPayloadContext } from '@/finsight/application/PortfolioMonitor/FormPayloadContext';
import { useMemo } from 'react';

export const useGetPositions = () => {
  const { payload, activeListName } = useFormPayloadContext();
  const listIndex = payload.lists.findIndex((item) => item.name === activeListName);
  const listPositions = useMemo(() => {
    return listIndex > -1 ? payload.lists[listIndex].positions : [];
  }, [payload, listIndex]);

  return {
    positions: listPositions,
    listIndex,
  };
};

export default useGetPositions;
